import { type Config } from 'tailwindcss';

export const extendedTheme = {
  colors: {
    border: 'var(--border)',
    input: {
      DEFAULT: 'var(--input)',
      invalid: 'var(--input-invalid)',
    },
    ring: {
      DEFAULT: 'var(--ring)',
      invalid: 'var(--foreground-destructive)',
    },
    background: 'var(--background)',
    foreground: {
      DEFAULT: 'var(--foreground)',
      destructive: 'var(--foreground-destructive)',
    },
    primary: {
      DEFAULT: 'var(--primary)',
      foreground: 'var(--primary-foreground)',
    },
    secondary: {
      DEFAULT: 'var(--secondary)',
      foreground: 'var(--secondary-foreground)',
    },
    destructive: {
      DEFAULT: 'var(--destructive)',
      foreground: 'var(--destructive-foreground)',
    },
    warning: {
      DEFAULT: 'var(--warning)',
    },
    muted: {
      DEFAULT: 'var(--muted)',
      foreground: 'var(--muted-foreground)',
    },
    accent: {
      DEFAULT: 'var(--accent)',
      foreground: 'var(--accent-foreground)',
    },
    popover: {
      DEFAULT: 'var(--popover)',
      foreground: 'var(--popover-foreground)',
    },
    card: {
      DEFAULT: 'var(--card)',
      foreground: 'var(--card-foreground)',
    },
    highlight: {
      DEFAULT: 'var(--highlight)',
      hover: 'var(--highlight-hover)',
    },
  },
  borderColor: {
    DEFAULT: 'var(--border)',
  },
  borderRadius: {
    lg: 'var(--radius)',
    md: 'calc(var(--radius) - 2px)',
    sm: 'calc(var(--radius) - 4px)',
  },
  fontSize: {
    'headline-bold': [
      '24px',
      { lineHeight: '34px', fontWeight: '600', letterSpacing: '0.5px' },
    ],
    'headline-semi': [
      '24px',
      { lineHeight: '34px', fontWeight: '400', letterSpacing: '0.5px' },
    ],
    subtitle: ['18px', { lineHeight: '30px', fontWeight: '400' }],
    body: ['14px', { lineHeight: '22px', fontWeight: '400' }],
    label: ['12px', { lineHeight: '20px', fontWeight: '400' }],
    button: ['14px', { lineHeight: '20px', fontWeight: '500' }],
  },
  fontFamily: {
    sans: ['var(--font-sans)'],
    mono: ['var(--font-mono)'],
  },
} satisfies Config['theme'];
